import { render, staticRenderFns } from "./rpterstdnotconfirmbyco.vue?vue&type=template&id=5b475911&"
import script from "./rpterstdnotconfirmbyco.vue?vue&type=script&lang=js&"
export * from "./rpterstdnotconfirmbyco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports